import { SvgIcon } from '@avantia/style-guide';
import { addDays } from 'date-fns';
import type { HpSvgIconTypes } from '@avantia/style-guide';
import { Card, Col, Row } from 'react-bootstrap';
import type { SetStateAction, Dispatch } from 'react';

import { formatAddress, formatDate, getDateWithoutTime } from 'utils';
import { getCoverTypeIcon } from 'utils';

import './multiplePolicyModal.scss';
import { useHistory, useLocation } from 'react-router';
import { addPolicyToPath } from './utils/addPolicyToPath';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { getCustomerPolicyAction } from 'actions/getCustomerPolicyAction';
import { Policy, FullPolicyData } from 'interfaces/customerDataTypes';
import { getStatusDetails } from 'components/feature/dashboard/policy/policyStatus/policyStatusConfig';

interface MultiplePolicyModalProps {
  policies: Policy[];
  setShow: Dispatch<SetStateAction<boolean>>;
  selectedPolicy?: FullPolicyData;
}

interface HandleSelectProps {
  selectedPolicyNumber: string;
  selectedPolicyDetailsId: string;
  selectedPolicyHistoryId: number;
}

export const MultiplePolicyModal = ({ policies, setShow, selectedPolicy }: MultiplePolicyModalProps): JSX.Element => {
  const history = useHistory();
  const { pathname } = useLocation();
  const dispatch = useAppDispatch();
  const { email: username, isAgent } = useAppSelector((state) => state.authentication);

  const handlePolicySelect = ({
    selectedPolicyNumber,
    selectedPolicyDetailsId,
    selectedPolicyHistoryId
  }: HandleSelectProps) => {
    if (!selectedPolicy || selectedPolicy.policyNumber !== selectedPolicyNumber) {
      history.replace(addPolicyToPath(pathname, selectedPolicyNumber));
      dispatch(
        getCustomerPolicyAction({
          policyDetailsId: selectedPolicyDetailsId,
          historyId: selectedPolicyHistoryId,
          policyNumber: selectedPolicyNumber,
          username,
          isAgent
        })
      );
    }

    setShow(false);
  };

  return (
    <div className={`multiple-policy-container ${isAgent ? 'with-agent-banner' : ''}`}>
      <h1>SELECT A POLICY</h1>
      <Row className="card-container" sm={3} xs={2}>
        {policies.map((policy) => (
          <Col key={policy.policyNumber} className="card-column">
            <a
              onClick={() =>
                handlePolicySelect({
                  selectedPolicyNumber: policy.policyNumber,
                  selectedPolicyDetailsId: policy.policyDetailsId,
                  selectedPolicyHistoryId: policy.historyId
                })
              }
              id={`${policy.policyNumber}-card`}>
              <Card className="policy-card">
                <SvgIcon type={getCoverTypeIcon() as HpSvgIconTypes} size="medium" />
                <h3>HOME INSURANCE</h3>
                <div>
                  <p className="bold-text">Address insured</p>
                  <p>{formatAddress(policy.riskAddress, policy.riskPostcode)}</p>
                  <p className="bold-text">Policy reference</p>
                  <p>{policy.policyNumber}</p>
                  <p className="bold-text">Policy status</p>
                  <p>
                    {getStatusDetails(policy.atlasLifecycleStatus, policy.customerRenewalOptOut, username).statusText}
                  </p>
                  <p className="bold-text">Renewal date</p>
                  <p>{formatDate(addDays(getDateWithoutTime(policy.policyEndDate), 1))}</p>
                </div>
              </Card>
            </a>
          </Col>
        ))}
      </Row>
    </div>
  );
};
